<template>
  <div>
    <va-card>
      <template slot="header">
        <div class="va-card__header-title" color="secondary">
          <router-link to="/">{{ $t('menu.dashboard') }}</router-link> / {{ $t('menu.users') }}
        </div>
      </template>

      <div class="row align--center mt-1">
        <div class="flex xs12 sm6 md3">
          <va-input
            v-model="filter.name"
            :label="$t('tables.searchBy.name')"
          />
        </div>
        <div class="flex xs12 sm6 md3">
          <va-input
            v-model="filter.surname"
            :label="$t('tables.searchBy.surname')"
          />
        </div>
        <div class="flex xs12 sm12 md3">
          <va-input
            v-model="filter.email"
            :label="$t('tables.searchBy.email')"
          />
        </div>
        <div class="flex xs9 sm10 md2">
          <va-input
            v-model="filter.mobile"
            :label="$t('tables.searchBy.phone')"
          />
        </div>
        <div class="flex xs3 sm2 md1">
          <div class="btn--wrapper">
            <va-button small outline @click.stop="onfilter" icon="fa fa-search"/>
            <va-button v-show="hasFilter" small outline @click.stop="onclearfilter" icon="fa fa-eraser"/>
          </div>
        </div>
      </div>

      <va-data-table
        :fields="fields"
        :data="items"
        :loading="loading"
        api-mode
        @row-clicked="show"
      >
        <template slot="created_at_readable" slot-scope="props">
          {{ formatDate(props.rowData.created_at_readable) }}
        </template>
      </va-data-table>
    </va-card>
    <va-pagination
      v-model="pages.current_page"
      :visible-pages="3"
      :pages="pages.last_page"
      class="mt-3"
      :small="true"
      color="secondary"
    />
  </div>
</template>

<script>
import moment from "moment"
import userServices from '../../services/api/user'
import responseMixin from '../../services/api/response'
import helperMixin from '../../services/helper'
export default {
  mixins: [responseMixin, helperMixin],
  data () {
    return {
      isMobile: false,
      loading: false,
      items: [],
      filter: {
        name: null,
        surname: null,
        email: null,
        mobile: null,
      },
      hasFilter: false,
      pages: {
        current_page: 1,
        last_page: 1
      },
    }
  },
  computed: {
    fields () {
      return [{
        name: 'name',
        title: this.$t('tables.headings.user.name'),
        width: '30%',
      }, {
        name: 'surname',
        title: this.$t('tables.headings.user.surname'),
        width: '30%',
      }, {
        name: 'email',
        title: this.$t('tables.headings.user.email'),
        width: '30%',
      }, {
        name: 'mobile',
        title: this.$t('tables.headings.user.phone'),
        width: '30%',
      }, {
        name: '__slot:created_at_readable',
        title: this.$t('tables.headings.user.createdAt'),
        dataClass: 'text-center',
      }]
    },
  },
  watch: {
    'pages.current_page': function(val) {
      let q = this.mergeQuery(q);;
      q.sayfa = val;
      this.$router.push({ path: '/uye/listesi', query: q });
      this.getUsers(val, JSON.parse(JSON.stringify(this.filter)));
    },
    '$route.query'(val) {
      this.splitQuery(val);
    }
  },
  methods: {
    formatDate (date) {
      if (date) {
        return moment(String(date)).format("DD.MM.YYYY");
      }
      return date;
    },
    async getUsers(page=1, filter = {}){
      this.loading = true;
      this.hasFilter = !!this.filter.name || !!this.filter.surname || !!this.filter.email || !!this.filter.mobile;

      filter.page = page;
      filter.limit = 15;
      if(!!filter.mobile) {
        filter.mobile = (filter.mobile).replace('+', '*');
      }
      if(!!filter.name) {
        filter.name = '*' + filter.name + '*';
      }
      if(!!filter.surname) {
        filter.surname = '*' + filter.surname + '*';
      }
      if(!!filter.email) {
        filter.email = '*' + filter.email + '*';
      }
      const result = await userServices.get('', {
          params: filter
        });
      if(result.error){
        this.items = [];
        return ;
      }
      this.loading = false;
      this.items = result.data.data;
      this.pages = result.data.meta;
    },
    onfilter () {
      let q = this.mergeQuery();
      q.sayfa = 1;
      this.$router.push({ path: '/uye/listesi', query: q });
      this.getUsers(1, JSON.parse(JSON.stringify(this.filter)));
    },
    onclearfilter () {
      this.$router.push({ path: '/uye/listesi' });
      this.filter = { name: null, surname: null, email: null, mobile: null };
      this.getUsers(1, {});
    },
    mergeQuery() {
      let q = {};
      if(!!this.filter.name) {
        q.isim = this.filter.name!="" ? this.filter.name : null;
      } else {
        this.filter.name = this.filter.name!="" ? this.filter.name : null;
      }
      if(!!this.filter.surname) {
        q.soyisim = this.filter.surname!="" ? this.filter.surname : null;
      } else {
        this.filter.code = this.filter.surname!="" ? this.filter.surname : null;
      }
      if(!!this.filter.email) {
        q.eposta = this.filter.email!="" ? this.filter.email : null;
      } else {
        this.filter.email = this.filter.email!="" ? this.filter.email : null;
      }
      if(!!this.filter.mobile) {
        q.gsm = this.filter.mobile!="" ? this.filter.mobile : null;
      } else {
        this.filter.mobile = this.filter.mobile!="" ? this.filter.mobile : null;
      }
      return q;
    },
    splitQuery(q) {
      let page = 1;
      if(q.sayfa) {
        page = parseInt(q.sayfa);
        delete q.sayfa;
      }
      if(q !== {}) {
        if(!!q.isim) {
          this.filter.name = q.isim;
        }
        if(!!q.soyisim) {
          this.filter.surname = q.soyisim;
        }
        if(!!q.eposta) {
          this.filter.email = q.eposta;
        }
        if(!!q.gsm) {
          this.filter.mobile = q.gsm;
        }
      }
      this.getUsers(page, JSON.parse(JSON.stringify(this.filter)));
    },
    show(item) {
      this.redirectTo('/rezervasyon/listesi?uye_no='+item.id)
    }
  },
  created() {
    this.isMobile = this.checkIsMobile();
    this.splitQuery(this.$route.query);
  }
}
</script>

<style lang="scss" scoped>
.btn--wrapper {
  position: relative;
  margin-top: -1rem;
}
</style>